import { Header } from "../components/Header";
import React, { useEffect, useState } from "react";
import LiveDarshanModal from "../components/LiveDarshanModal";
import { Link } from "react-router-dom";

export const Ambajogai = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState({ title: "", url: "" });
  const [showTimetableModal, setShowTimetableModal] = useState(false);

  const [videoUrl, setVideoUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");

  const openModal = () => {
    setSelectedVideo({
      title: "LIVE DARSHAN",
      url: "https://www.youtube.com/embed/oBJCYcle6_U",
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => {
      setSelectedVideo({ title: "", url: "" });
    }, 250);
  };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="w-full  flex flex-col items-center justify-center">
                <Header/>
                <img
                    src="/other_imgs/banner-dharmik-inside.jpg"
                    alt="Information Banner"
                    className="w-full object-cover shadow-lg"
                />
            </div>

      <h1 className="text-center font-bold text-3xl mt-10 text-red-800">
        योगेश्वरी देवी, अंबाजोगाई
      </h1>

            <div className="flex flex-col-reverse md:flex-row justify-between p-10">
                {/* Left Section - Image and Text */}
                <div className="w-full md:w-1/2 p-4">
                    <div className="flex items-center justify-center">
                        <img
                            src="/other_imgs/thumbnail-dharmik-ambajogai.png"
                            alt="Temple Idol"
                            className="shadow-md w-80 h-80 md:w-[550px] md:h-[550px] object-cover"
                        />
                    </div>
                    <p className="mt-10 leading-relaxed px-5 text-justify">
                        मराठवाड्यातील आंबेजोगाईची अंबापुरवासिनी श्री योगेश्वरी देवी ही बहतेक
                        सर्वच चित्तपावन कोकणस्थ ब्राह्मणांची कुलदेवता आहे. त्यामुळे
                        महाराष्ट्रातील सर्व भागांतून या देवीच्या दर्शनास भक्तगण येत असतात.
                        अत्रिगोत्रीय चित्पावन जोगळेकर कुटुंबीयांची तर ही दंतासुरमर्दिनी,
                        राजराजेश्वरीदेवी, विशेष शक्ती असलेली कुलस्वामिनीच आहे. ह्या श्री
                        योगेश्वरी देवीच्या देवस्थानाच्या स्थापनेचा काळ सुमारे दीड हजार
                        वर्षांपूर्वींचा मानला जातो. आंबेजोगाई शहराच्या मध्यभागातून वाहणाऱ्या
                        जयंती नदीच्या पश्चिमकाठावर श्री योगेश्वरी देवीचे, हेमाडपंती रचनेचे,
                        उत्तराभिमुख मंदिर वसलेले आहे. श्री योगेश्वर देवीचे वार्षिक उत्सव,
                        अश्विन व मार्गशीर्ष महिन्यात साजरे केले जातात. अष्टमी व नवमी
                        तिथीच्या संधिकालावर शतचंडी हवनावर पूर्णाहती होते. मार्गशीर्ष
                        महिन्यांत शुध्द सप्तमीपासून घटस्थापना होऊन पौर्णिमेच्या दिवशी शतचंडी
                        यज्ञाची पूर्णाहती होते. मार्गशीर्ष पौर्णिमा हा श्री योगेश्वरी देवीचा
                        अवतारदिवस आहे. या दिवशी देवीला भोग चढवितात. जोगळेकर कुटुंबीय
                        व्यक्तींना, कुलस्वामिनीचे आयुष्यात गकदा तरी दर्शन घेणे आवश्यक आहे
                        असे मानतात. लग्नानंतर जोडप्याने कुलस्वामिनीचे दर्शन घेण्याची प्रथा
                        आहे. ह्या आंबेजोगाईच्या श्री योगेश्वरी देवीच्या दर्शनाला िंकवा
                        धर्मकृत्यांकरिता आंबेजोगाईस जाणाऱ्यांनी ह्या देवस्थानाचे
                        क्षेत्रउपाध्याय यांची मदत घ्यावी. १. क्षेत्र उपाध्याय भिकाजी काशिनाथ
                        पाठकशास्त्री. २. क्षेत्र उपाध्याय वसंत मार्तंड औसेकर-पाठक.
                    </p>
                </div>

                {/* Right Section - Buttons */}
                <div className="flex-1 flex flex-col items-center mb-6">
                    <button
                        className="bg-red-600 text-white font-bold text-lg px-6 py-2 rounded-xl mb-4 shadow hover:bg-red-700 flex items-center justify-center w-full max-w-xs h-14"
                        onClick={openModal}
                    >
                        <img
                            src="/other_imgs/icon-live-recording-dot.png"
                            className="w-6 h-6 mr-4"
                        />
                        LIVE DARSHAN
                    </button>

                    <button
                        className="bg-red-600 text-white font-bold text-lg px-6 py-2 rounded-xl mb-4 shadow hover:bg-red-700 flex items-center justify-center w-full max-w-xs h-14">
                        <img
                            src="/other_imgs/icon-temple-timetable.png"
                            className="w-6 h-6 mr-4"
                        />
                        TEMPLE TIME TABLE
                    </button>

                    <button
                        className="bg-red-600 text-white font-bold text-lg px-6 py-2 rounded-xl mb-4 shadow hover:bg-red-700 flex items-center justify-center w-full max-w-xs h-14">
                        Book Puja
                    </button>

                    {/* Aarti and Mantropchar */}
                    <div className="flex flex-col sm:flex-row gap-4 mt-6">
                        <Link to="/yogeshwari_aarti">
                            <div
                                className="bg-gradient-to-tr from-orange-400 via-orange-500 to-orange-700 font-bold text-lg text-white px-6 py-2 rounded-xl shadow flex items-center justify-center w-80 h-16">
                                <img
                                    src="/other_imgs/thumbnail-aarti.jpg"
                                    className="w-8 h-8 rounded-lg mr-3"
                                />
                                Aarti
                            </div>
                        </Link>

                        <Link to="/yogeshwari-devi-mantropchar">
                            <div
                                className="bg-gradient-to-tr from-orange-400 via-orange-500 to-orange-700 font-bold text-lg text-white px-6 py-2 rounded-xl shadow flex items-center justify-center w-80 h-16">
                                <img
                                    src="/other_imgs/thumbnail-mantropchar.jpg"
                                    className="w-8 h-8 rounded-lg mr-3"
                                />
                                Mantropchar
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

      {/* Modal */}
      <LiveDarshanModal
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        selectedVideo={selectedVideo}
      />
    </>
  );
};
